import { useViewPort } from "@website/hooks/viewport";
import { getChannel } from "@website/utils/channel/get-channel";
import { isChannel } from "@website/utils/channel/helpers";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { useEffect } from "react";

const Main = () => {
  const { isDesktop } = useViewPort();
  const router = useRouter();
  const channel = getChannel();

  useEffect(() => {
    if (isChannel(["jek"]) && router?.query?.source) {
      window?.webengage?.track("st-main-profile-viewed", {
        source: router?.query?.source
      });
    }
    if (isDesktop) {
      router.replace("/information");
    }
  }, [channel, isDesktop, router]);

  return <div className="flex w-full flex-1 items-center justify-center"></div>;
};

export default Main;

export const getServerSideProps: GetServerSideProps = async () => ({
  props: {}
});
